<template>
  <div class="home">
    <!-- 导航条 -->
    <!-- <van-nav-bar title="智慧校园-教师" fixed /> -->
    <!-- 轮播图 -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.imgUrl">
        <img :src="item.imgUrl" alt="">
      </van-swipe-item>
    </van-swipe>
    <!-- 班级选择 -->
    <div class="class-selection">
      <!-- <van-field readonly clickable name="picker" :value="currentClass" label="我的班级" placeholder="点击选择班级"
        @click="showPicker = true" /> -->
      <div style="padding: 10px 20px;font-size: 14px;" @click="showPicker = true"><span style="font-weight: bold;">我的班级:</span> {{ currentClass }} <van-icon name="arrow-down" /></div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="classList" value-key="name" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
    </div>
    <!-- 导航 -->
    <div v-for="(value, index) in navList" :key="index">
      <h5 style="padding: 10px 20px;">{{ value.title }}</h5>
      <van-grid column-num="3" icon-size="40">
        <van-grid-item v-for="item in value.menu" :key="item.imgUrl" :icon="item.imgUrl" :text="item.text"
          @click="clickTab(item)"/>
      </van-grid>
    </div>

    <!-- 主会场 -->
    <!-- <div class="main">
      <img src="@/assets/main.png" alt="">
    </div> -->

  </div>
</template>

<script>
import { getHomeData, getClassList,useLogout} from '@/api/home'
import { getInfo } from '@/utils/storage'
export default {
  name: 'HomePage',
  components: {},
  data () {
    return {
      bannerList: [],
      navList: [],
      userInfo: {},
      classList: [],
      showPicker: false,
      currentClass: '请选择班级'
    }
  },
  async created () {
    const isLogin = this.$store.getters.token
    console.log('isLogin', isLogin)
    if (!isLogin) {
      this.$router.push('/login')
      return
    }
    // 获取用户信息
    const userInfo = getInfo()
    console.log('userInfo', userInfo)
    this.userInfo = userInfo

    const response = await getHomeData(userInfo.identify)
    console.log('pageData', response)

    this.bannerList = response.data.bannerList
    this.navList = response.data.navList

    //获取最新班级列表
    let classes = await getClassList(userInfo.userId)
    this.classList=classes.data
    localStorage.setItem('currentClass', JSON.stringify(classes.data[0]))
    this.currentClass = classes.data[0].name
  },
  methods: {
    onConfirm (value, index) {
      console.log('onConfirm', value, index)
      this.currentClass = value.name
      this.showPicker = false
      //更新缓存的数据
      localStorage.setItem('currentClass', JSON.stringify(value))
      // this.$toast(`已切换到${value.name}`)
      
      // 刷新当前页面
      // this.$router.go(0)
    },
    clickTab (item) {
      console.log(item)
      if( item.text==="退出登录" ){
         this.logout()
      }else{
        this.$router.push({
          path: item.path,
        })
      }
    },
    logout () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '你确认要退出么'
      }).then(() => {
        const userInfo = getInfo()
        let params = {
          uid: userInfo.userId
        }
        useLogout(params).then(res => {})
        // 退出是一个动作 => 包含了两步，分别是将 user 和 cart 进行重置
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }).catch(() => {})
    },
  }
}
</script>

<style lang="less" scoped>
// 主题 padding
.home {
  // padding-top: 100px;
  // padding-bottom: 50px;
  padding-bottom: 100px;
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
  background-color: #379623;
  ::v-deep .van-nav-bar__title {
    color: #0c0c0c;
  }
}
// 分类导航部分
.my-swipe .van-swipe-item {
  // height: 255px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  // background-color: #39a9ed;
}
.my-swipe .van-swipe-item img {
  width: 100%;
  // height: 255px;
}

// 主会场
.main img {
  display: block;
  width: 100%;
}
</style>
